import React from 'react';
import { hot } from 'react-hot-loader';
import { FocusStyleManager } from '@el8/vital';
import { Router } from '@reach/router';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import BookingHeader from 'views/Header/BookingHeader';
import Booking from 'views/booking/Booking/Booking';
import AppointmentManagerContainer from 'views/manage-appointment/AppointmentManagerContainer';
import Account from 'views/booking/Account/Account';
import Confirmation from 'views/booking/Confirmation/Confirmation';
import Success from 'views/booking/Success/Success';
import Practice from 'views/booking/Practice/Practice';
import AddPatient from 'views/booking/AddPatient/AddPatient';
import ServiceLocation from 'views/booking/ServiceLocation/ServiceLocation';

import styles from './App.less';

FocusStyleManager.onlyShowFocusOnTabs();

export type AppProps = {
  children?: React.ReactNode;
};

const queryClient = new QueryClient({
  defaultOptions: { queries: { refetchOnWindowFocus: false } },
});

export const App: React.FC = () => {
  const practiceId = window.el8Globals.PRACTICE_ID;
  const isAvailabilityOnBkSiteEnabled = window.el8Globals.FEATURES.AvailabilityOnBkSite;
  return (
    <div className={styles.app}>
      <QueryClientProvider client={queryClient}>
        <Router>
          <AppointmentManagerContainer path="book/appointments/:appointmentId/manage" />
          <Booking practiceId={practiceId} path="book/:practiceSlug">
            <Practice practiceId={practiceId} path="/" />
            <Practice practiceId={practiceId} path=":appointmentTypeUrl" />
            {isAvailabilityOnBkSiteEnabled && (
              <ServiceLocation
                practiceId={practiceId}
                path="service-locations/:serviceLocationId"
              />
            )}
            <Account practiceId={practiceId} path="account" />
            <AddPatient practiceId={practiceId} path="add-patient" />
            <Confirmation practiceId={practiceId} path="confirmation" />
            <Success practiceId={practiceId} path="success" />
          </Booking>
        </Router>
      </QueryClientProvider>
      <BookingHeader practiceId={practiceId} />
    </div>
  );
};

export default hot(module)(App);
